const de = {
  // Navigation
  nav_plan: 'Planen',
  nav_itinerary: 'Reiseplan',
  nav_saved: 'Gespeichert',

  // Header
  explore_photos: 'Fotos entdecken',
  sign_in: 'Anmelden',

  // Plan screen
  new_trip: '+ Neue Reise',
  add_city_header: 'Stadt hinzufügen',
  city_placeholder: 'Stadtname eingeben…',
  add_cities_empty: 'Städte hinzufügen, um die Reise zu planen',
  dest_bangkok: 'Bangkok', dest_paris: 'Paris', dest_london: 'London', dest_dubai: 'Dubai',
  dest_singapore: 'Singapur', dest_tokyo: 'Tokio', dest_new_york: 'New York',
  dest_istanbul: 'Istanbul', dest_kuala_lumpur: 'Kuala Lumpur', dest_seoul: 'Seoul',
  hero_badge: 'KI-gestützte Reiseplanung',
  hero_title_line1: 'Deine nächste Reise,',
  hero_title_line2: 'perfekt geplant.',
  hero_subtitle: 'Tippe auf ein Ziel und starte sofort mit der Planung',
  most_visited_label: 'Beliebteste Reiseziele',
  popular_destinations: 'Beliebte Reiseziele',
  or_type_your_own: 'oder eigene Stadt eingeben',
  where_going_label: 'Wohin möchtest du reisen?',
  expanding_region: (r) => `Suche nach den besten Städten in ${r}…`,
  tap_to_explore: '— zum Entdecken tippen',
  attraction_count: (n) => `${n} ${n === 1 ? 'Sehenswürdigkeit' : 'Sehenswürdigkeiten'}`,
  show_less: 'Weniger anzeigen',
  read_more: 'Mehr lesen',
  more: 'Mehr',
  less: 'Weniger',
  no_attractions: 'Noch keine Sehenswürdigkeiten hinzugefügt',
  add_attraction_placeholder: (city) => `Sehenswürdigkeit in ${city} hinzufügen…`,
  auto_add_title: 'Empfehlungen automatisch hinzufügen',
  preferences_label: 'Interessen',
  all_types_label: 'Alle Typen',
  edit_interests: 'Interessen bearbeiten…',
  plan_framing_msg: 'Behalte, was dir gefällt, entferne den Rest — dann erstelle deinen Tagesplan.',
  add_back: 'Wiederherstellen',
  added_label: 'Hinzugefügt',
  refresh_attractions: 'Sehenswürdigkeiten aktualisieren',
  plan_multi_summary: (n, m) => `${n} ${n === 1 ? 'Stadt' : 'Städte'} · ${m} Orte`,
  filter_onboarding_msg: 'Sehenswürdigkeiten personalisieren',
  filter_onboarding_sub: 'Tippe auf einen Typ — wir passen deine Vorschläge an.',
  explore_nearby: 'Umgebung erkunden',
  explore_nearby_sub: 'Fotos der Highlights deiner Reise ansehen',
  finding_attractions: 'Sehenswürdigkeiten suchen…',
  finding_attractions_1: 'KI nach Top-Tipps fragen…',
  finding_attractions_2: 'Highlights werden gesucht…',
  finding_attractions_3: 'Fast fertig…',
  generating_msg_1: 'Ihre Tage planen…',
  generating_msg_2: 'Die besten Orte finden…',
  generating_msg_3: 'Reiseplan erstellen…',
  view_itinerary: 'Reiseplan anzeigen',
  generate_itinerary: 'Reiseplan erstellen',
  filterLabel: (label) => ({ 'All': 'Alle', 'Culture': 'Kultur', 'Nature': 'Natur', 'Entertainment': 'Unterhaltung', 'Shopping': 'Shopping', 'Food & Drink': 'Essen & Trinken', 'Kids': 'Kinder', 'Seniors': 'Senioren' })[label] ?? label,

  // Itinerary screen
  rename: 'Umbenennen',
  days: (n) => `${n} ${n === 1 ? 'Tag' : 'Tage'}`,
  unsaved_dot: 'Ungespeicherte Änderungen',
  share_itinerary: 'Reiseplan teilen',
  copy: 'Kopieren',
  copied: 'Kopiert!',
  add_more_attractions: 'Weitere Sehenswürdigkeiten',
  search_city_placeholder: 'Stadt suchen…',
  plus_city: '+ Stadt',
  your_cities: 'Deine Städte',
  unscheduled_count: (n) => `Ungeplante Sehenswürdigkeiten (${n})`,
  drag_to_schedule: 'Auf einen Tag ziehen, um zu planen',
  loading_details: 'Details werden geladen…',
  drag_here: 'Sehenswürdigkeit hierher ziehen',
  day_label: (n) => `Tag ${n}`,
  activity_count: (n) => `${n} ${n === 1 ? 'Aktivität' : 'Aktivitäten'}`,
  add_note: '+ Notiz hinzufügen',
  note_placeholder: 'Notizen für diesen Tag – Hotel, Mittagessen, Erinnerungen…',
  save_note: 'Notiz speichern',
  cancel: 'Abbrechen',
  continue_in_city: 'In einer vorhandenen Stadt fortfahren',
  change_back: '← Ändern',
  save: 'Speichern',
  hotel_nights_label: 'Nächte',
  hotel_name_label: 'Hotelname',
  restaurant_label: 'Restaurant (optional)',
  search_hotel: 'Hotel suchen…',
  search_restaurant: 'Restaurant suchen…',
  searching: 'Suche läuft…',
  address_label: 'Adresse',
  time_label: 'Uhrzeit',
  duration_label: 'Dauer',
  notes_label: 'Notizen',
  time_placeholder: 'z. B. 9:00 Uhr',
  duration_placeholder: 'z. B. 2 Stunden',
  notes_placeholder: 'z. B. Check-in um 15 Uhr, Zimmer mit Poolblick…',
  drag_to_reorder: 'Zum Sortieren ziehen',
  details: 'Details',
  edit: 'Bearbeiten',
  snip: 'Snip',
  remove: 'Entfernen',
  move_to_day_picker: 'Zu Tag verschieben…',
  trip_start_date: 'Reise beginnt',
  itinerary_photo_sub: 'KI-Empfehlungen basierend auf deinen Städten',
  itinerary_photo_cta: 'Entdecke verborgene Schätze für deine Reise',
  hotel: 'Hotel',
  meal_at: (restaurant) => `bei ${restaurant}`,
  add_day: 'Tag hinzufügen',
  save_changes: 'Änderungen speichern',
  saved_check: 'Gespeichert ✓',
  save_itinerary: 'Reiseplan speichern',
  print_export: '🖨️ Drucken / PDF exportieren',
  photos_details: 'Fotos & Details',

  // Saved screen
  snip_requires_account: 'Erstelle ein kostenloses Konto, um Lesezeichen zu speichern',
  sign_in_to_save:'Anmelden, um Reisen zu speichern und anzusehen',
  sign_in_or_create: 'Anmelden oder Konto erstellen',
  snips: 'Snips',
  place_count: (n) => `${n} ${n === 1 ? 'Ort' : 'Orte'}`,
  trips: 'Reisen',
  loading_trips: 'Reisen werden geladen…',
  no_saved_trips: 'Noch keine gespeicherten Reisen',
  add_to_plan: 'Zum Plan hinzufügen',
  add_to_itinerary_btn: 'Zum Reiseplan hinzufügen',
  untitled_trip: 'Unbenannte Reise',
  open: 'Öffnen',

  // User menu
  signed_in_as: 'Angemeldet als',
  change_password: 'Passwort ändern',
  delete_user_menu: 'Benutzer löschen',
  sign_out: 'Abmelden',

  // Load saved trip confirmation
  load_trip_confirm_title: 'Gespeicherte Reise öffnen?',
  load_trip_confirm_msg: 'Dein aktueller Plan wird verworfen. Speichere ihn zuerst, wenn du ihn behalten möchtest.',

  // New trip confirmation
  unsaved_changes_title: 'Ungespeicherte Änderungen',
  unsaved_changes_msg: 'Deine aktuelle Reise hat ungespeicherte Änderungen. Trotzdem neue Reise starten?',
  discard_start_new: 'Verwerfen & neu starten',
  new_trip_tab_title: 'Neue Reise starten?',
  new_trip_tab_msg: 'Deine aktuelle Reise wird gelöscht. Speichere sie zuerst, wenn du sie behalten möchtest.',
  start_fresh: 'Neu starten',

  // Auth modal
  create_account: 'Konto erstellen',
  email_placeholder: 'E-Mail',
  password_placeholder: 'Passwort',
  i_agree_to: 'Ich stimme den',
  terms_of_service: 'Nutzungsbedingungen',
  privacy_policy: 'Datenschutzrichtlinie',
  and: 'und der',
  no_account: 'Noch kein Konto? ',
  have_account: 'Bereits ein Konto? ',
  network_error: 'Netzwerkfehler, bitte erneut versuchen',
  err_email_exists: 'Ein Konto mit dieser E-Mail-Adresse existiert bereits',
  err_invalid_credentials: 'Ungültige E-Mail oder falsches Passwort',
  err_email_password_required: 'E-Mail und Passwort sind erforderlich',
  err_password_too_short: 'Das Passwort muss mindestens 6 Zeichen lang sein',

  // Change password modal
  select_user: 'Benutzer auswählen…',
  new_password_placeholder: 'Neues Passwort (mind. 6 Zeichen)',
  update_password: 'Passwort aktualisieren',
  password_updated: 'Passwort aktualisiert',
  select_a_user: 'Einen Benutzer auswählen',
  network_error_short: 'Netzwerkfehler',

  // Delete user modal
  delete_user_trips: 'Benutzer & Reisen löschen',
  deleted_user: (email) => `${email} gelöscht`,

  // Photo mode
  photo_loading_msg_1: 'Tolle Orte für dich suchen…',
  photo_loading_msg_2: 'Fotos und Details prüfen…',
  photo_loading_msg_3: 'Fast fertig…',
  finding_places: 'Orte für dich suchen…',
  could_not_load_places: 'Orte konnten nicht geladen werden',
  no_places: 'Keine Orte zum Anzeigen',
  ai_error: 'Problem mit der KI. Bitte in einem Moment erneut versuchen.',
  add_cities_suggestions: 'Städte hinzufügen oder Orte merken für personalisierte Vorschläge.',
  retry: 'Erneut versuchen',
  close: 'Schließen',
  finding_more_places: 'Weitere Orte suchen…',
  seen_it_all: 'Du hast alles gesehen!',
  photo_limit_msg: 'Du hast das Limit von 50 Orten für diese Sitzung erreicht.',
  check_snips: 'Sieh dir deine Snips an, um gespeicherte Orte zu überprüfen',
  photo_unavailable: 'Foto nicht verfügbar',
  loading: 'Wird geladen…',
  skip: 'Überspringen',
  plus_itinerary: '+ Reiseplan',
  plus_plan: '+ Plan',
  photo_explore_title: 'Foto-Entdeckung',
  photo_explore_sub: 'Orte visuell entdecken',
  swipe_lr: 'Links oder rechts wischen zum Überspringen',
  swipe_up: 'Nach oben wischen zum Überspringen',
  lets_go: 'Los geht\'s',
  tutorial_skip_desc: 'Diesen Ort überspringen',
  tutorial_snip_desc: 'In deine Snips-Sammlung zum späteren Ansehen speichern',
  tutorial_add_plan_desc: 'Zum Reiseplan-Tab hinzufügen',
  tutorial_add_itinerary_desc: 'Direkt in dein aktuelles Reiseprogramm einfügen',
  tutorial_swipe_hint: 'Du kannst auch links, rechts oder nach oben wischen, um zu überspringen',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: 'Nutzungsbedingungen',
  privacy: 'Datenschutz',
  sample_itineraries: 'Beispiel-Reiserouten',
  browse_all_itineraries: 'Alle ansehen →',

  // Legal overlay
  back_to_app: '← Zurück zu SnipTrip',

  // Error boundary
  something_wrong: 'Etwas ist schiefgelaufen',
  reload: 'Neu laden',

  // Print view
  copy_text: 'Text kopieren',
  copied_check: '✓ Kopiert',

  // Logic / computed strings
  copy_of: (name) => `Kopie von ${name}`,
  transportation: 'Transport',
  meal: 'Mahlzeit',

  // Chat mode
  chat_mode_link: 'oder mit AI-Chat planen',
  chat_back: '← Zurück zur Übersicht',
  chat_input_placeholder: 'Nachricht…',
  chat_error: 'Etwas ist schiefgelaufen. Erneut versuchen?',
  chat_cities_count: (n) => n === 1 ? '1 Stadt' : `${n} Städte`,
  chat_places_count: (n) => n === 1 ? '1 Ort' : `${n} Orte`,
  chat_no_cities: 'Noch keine Städte hinzugefügt',

  // Discovery panels
  thinking_where: 'Ich denke nach, wohin ich dich bringen soll…',
  couldnt_load_suggestions: 'Vorschläge konnten nicht geladen werden. Erneut versuchen?',
  back: '← Zurück',
  no_new_suggestions: 'Keine neuen Vorschläge – andere Frage versuchen.',
  back_to_questions: '← Zurück zu den Fragen',
  dismiss: 'Schließen',
  where_to_next_header: 'Wohin als Nächstes?',
  describe_place: 'Ort beschreiben…',
  go: 'Los',
  finding_ideas: 'Ideen suchen…',
  more_attractions: 'Mehr Sehenswürdigkeiten…',
  different_angle: 'Oder aus einem anderen Blickwinkel erkunden:',
  mood_for: 'Worauf hast du Lust?',
  back_questions_short: '← Fragen',
  describe_looking_for: 'Was suchst du?',
  where_to_next_trigger: (city) => city ? `+ Wohin als Nächstes nach ${city}?` : '+ Wohin als Nächstes?',
  what_else_trigger: (city) => `+ Was soll ich noch in der Nähe von ${city} hinzufügen?`,
  day_chip_add_attraction: 'Eine Sehenswürdigkeit hinzufügen',
  day_chip_add_city: 'Eine Stadt in der Nähe hinzufügen',
  auto_populate_prompt: (city) => `Beliebte Attraktionen für ${city} vorschlagen?`,
  auto_populate_yes: 'Ja, vorschlagen',
  auto_populate_no: 'Nein, ich füge selbst hinzu',
  or_discover_new: '+ Oder woanders entdecken',
  select: 'Auswählen',
  add: 'Hinzufügen',
  freeform_cta: 'Anderes — selbst beschreiben',
};

export default de;
